export function generateRoomCode() {
    const length = 9;
    const charset = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let roomCode = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        if (i % 3 === 0 && i != 0) {
            roomCode += '-';
        }
        roomCode += charset[randomIndex];
    }
    return roomCode;
}
